var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { forEach, isNil, map } from 'lodash';
import { PanoViewer } from '@egjs/view360';
import screenfull from 'screenfull';
var InteriorPanoramaViewer = /** @class */ (function (_super) {
    __extends(InteriorPanoramaViewer, _super);
    function InteriorPanoramaViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.fullscreenChangeHandler = function () {
            var _a;
            var container = document.getElementById('interior_panorama');
            if (isNil(container)) {
                return;
            }
            // @ts-ignore
            if (screenfull.isFullscreen) {
                // console.log('entered fullscreen');
            }
            else {
                container.style.width = _this.state.containerSize.width + "px";
                container.style.height = _this.state.containerSize.height + "px";
                (_a = _this.state.panoViewer) === null || _a === void 0 ? void 0 : _a.updateViewportDimensions();
                // @ts-ignore
                screenfull.off('change', _this.fullscreenChangeHandler);
            }
        };
        /**
         * Returns if panorama is currently in fullscreen view
         */
        _this.isFullscreen = function () {
            // @ts-ignore
            return screenfull.isFullscreen;
        };
        _this.state = {
            panoViewer: null,
            animationFrameID: 0,
            autorotating: false,
            start: 0,
            containerSize: {
                width: 0,
                height: 0,
            },
            hotspots: [],
            hotspotsShown: true,
            panorama: props.project.interiorPanoramas[props.panoramaIndex],
        };
        return _this;
    }
    InteriorPanoramaViewer.prototype.componentDidMount = function () {
        var _this = this;
        var _a;
        var container = document.getElementById('interior_panorama');
        if (!isNil(container)) {
            var pitch = void 0, yaw = void 0, fov = void 0;
            if (isNil(this.props.initialPitch)) {
                pitch = 0;
            }
            else {
                pitch = this.props.initialPitch;
            }
            if (isNil(this.props.initialYaw)) {
                yaw = 0;
            }
            else {
                yaw = this.props.initialYaw;
            }
            if (isNil(this.props.initialZoom)) {
                fov = 65;
            }
            else {
                fov = this.props.initialZoom;
            }
            var pano_1 = new PanoViewer(container, {
                image: this.props.projectLocation + "/" + this.state.panorama.photo,
                projectionType: PanoViewer.PROJECTION_TYPE.EQUIRECTANGULAR,
                pitch: pitch,
                yaw: yaw,
                fov: fov,
            });
            this.setState({ panoViewer: pano_1, autorotating: false, hotspots: [] });
            if (!isNil(this.props.autorotateOnStart) && this.props.autorotateOnStart) {
                var speed_1 = (_a = this.props.autorotateSpeed) !== null && _a !== void 0 ? _a : 100;
                setTimeout(function () {
                    _this.autorotate(true, speed_1);
                }, 100);
            }
            var updateHotspotOffsets_1 = function () {
                var pano = _this.state.panoViewer;
                if (!isNil(pano)) {
                    forEach(_this.state.hotspots, function (hotspot) {
                        _this.setHotspotOffset(hotspot, pano);
                    });
                }
            };
            if (!isNil(this.state.panorama.detailPhotos) &&
                this.state.panorama.detailPhotos.length > 0) {
                var hotspotStyle_1 = {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    display: 'block',
                    zIndex: 2,
                };
                var hotspots = map(this.state.panorama.detailPhotos, function (detailPhoto) {
                    if (isNil(_this.props.createHotspotMarker)) {
                        var element = (React.createElement("div", { id: "panorama_detail_" + detailPhoto.name, className: 'interior_panorama_hotspot', style: hotspotStyle_1, onClick: function (event) {
                                _this.props.onHotspotSelected && _this.props.onHotspotSelected(detailPhoto, event);
                            } },
                            React.createElement("svg", { width: "48px", height: "48px", viewBox: "0 0 48 48", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                                React.createElement("title", null, "search"),
                                React.createElement("g", { id: "search", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
                                    React.createElement("g", { id: "info" },
                                        React.createElement("circle", { id: "Oval", "fill-opacity": "0.2", fill: "#000000", cx: "24", cy: "24", r: "24" }),
                                        React.createElement("line", { x1: "25.8166889", y1: "28.1192806", x2: "37.3532758", y2: "36.0506841", id: "Line-3", stroke: "#FFFFFF", "stroke-width": "3", "stroke-linecap": "round", transform: "translate(31.584982, 32.084982) rotate(10.491477) translate(-31.584982, -32.084982) " }),
                                        React.createElement("circle", { id: "Oval", stroke: "#FFFFFF", "stroke-width": "3", "stroke-linecap": "round", "stroke-linejoin": "round", cx: "19", cy: "19", r: "10" }))))));
                        return { detailPhoto: detailPhoto, element: element };
                    }
                    else {
                        return {
                            detailPhoto: detailPhoto,
                            element: (React.createElement("div", { id: "panorama_detail_" + detailPhoto.name, className: 'interior_panorama_hotspot', style: hotspotStyle_1 }, "this.props.createHotspotMarker(detailPhoto)"))
                        };
                    }
                });
                this.setState({ hotspots: hotspots });
                pano_1.on('ready', function (_e) {
                    updateHotspotOffsets_1();
                    if (!isNil(_this.props.hotspotsInitialyShown)) {
                        if (!_this.props.hotspotsInitialyShown) {
                            _this.hideHotspots();
                        }
                        _this.setState({ hotspotsShown: _this.props.hotspotsInitialyShown });
                    }
                });
                pano_1.on('viewChange', function (_e) {
                    updateHotspotOffsets_1();
                });
            }
            else {
                this.setState({ hotspots: [] });
            }
            window.addEventListener('resize', function (_e) {
                pano_1.updateViewportDimensions();
                updateHotspotOffsets_1();
            });
        }
    };
    /**
     * Move the view of the panorama the specified amount of degress to the left in the specified amount of time
     *
     * @param angles angle in degree by which the panorama should be moved to the left
     * @param duration duration in milliseconds this move should take
     */
    InteriorPanoramaViewer.prototype.moveLeft = function (angles, duration) {
        if (!isNil(this.state.panoViewer)) {
            var currentYaw = this.state.panoViewer.getYaw();
            this.state.panoViewer.lookAt({ yaw: currentYaw + angles }, duration);
        }
    };
    /**
     * Move the view of the panorama the specified amount of degress to the right in the specified amount of time
     *
     * @param angles angle in degree by which the panorama should be moved to the right
     * @param duration duration in milliseconds this move should take
     */
    InteriorPanoramaViewer.prototype.moveRight = function (angles, duration) {
        if (!isNil(this.state.panoViewer)) {
            var currentYaw = this.state.panoViewer.getYaw();
            this.state.panoViewer.lookAt({ yaw: currentYaw - angles }, duration);
        }
    };
    /**
     * Move the view of the panorama up the specified amount of degress in the specified amount of time
     *
     * @param angles angle in degree by which the panorama should be moved up
     * @param duration duration in milliseconds this move should take
     */
    InteriorPanoramaViewer.prototype.moveUp = function (angles, duration) {
        if (!isNil(this.state.panoViewer)) {
            var currentPitch = this.state.panoViewer.getPitch();
            this.state.panoViewer.lookAt({ pitch: currentPitch + angles }, duration);
        }
    };
    /**
     * Move the view of the panorama down the specified amount of degress in the specified amount of time
     *
     * @param angles angle in degree by which the panorama should be moved down
     * @param duration duration in milliseconds this move should take
     */
    InteriorPanoramaViewer.prototype.moveDown = function (angles, duration) {
        if (!isNil(this.state.panoViewer)) {
            var currentPitch = this.state.panoViewer.getPitch();
            this.state.panoViewer.lookAt({ pitch: currentPitch - angles }, duration);
        }
    };
    /**
     * Zoom into the panorama by the specified amount in the specified time
     *
     * @param amount amount of zoom in
     * @param duration duration in milliseconds this move should take
     */
    InteriorPanoramaViewer.prototype.zoomIn = function (amount, duration) {
        if (!isNil(this.state.panoViewer)) {
            var currentFov = this.state.panoViewer.getFov();
            this.state.panoViewer.lookAt({ fov: currentFov - amount }, duration);
        }
    };
    /**
     * Zoom out of the panorama by the specified amount in the specified time
     *
     * @param amount amount of zoom out
     * @param duration duration in milliseconds this move should take
     */
    InteriorPanoramaViewer.prototype.zoomOut = function (amount, duration) {
        if (!isNil(this.state.panoViewer)) {
            var currentFov = this.state.panoViewer.getFov();
            this.state.panoViewer.lookAt({ fov: currentFov + amount }, duration);
        }
    };
    /**
     * Display a fullscreen view of the panorama
     */
    InteriorPanoramaViewer.prototype.enterFullScreen = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var container, sizes;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        container = document.getElementById('interior_panorama');
                        if (!(!isNil(container) && screenfull.isEnabled)) return [3 /*break*/, 2];
                        sizes = {
                            width: container.getBoundingClientRect().width,
                            height: container.getBoundingClientRect().height,
                        };
                        return [4 /*yield*/, screenfull.request(container)];
                    case 1:
                        _b.sent();
                        container.style.width = '100%';
                        container.style.height = '100%';
                        (_a = this.state.panoViewer) === null || _a === void 0 ? void 0 : _a.updateViewportDimensions();
                        this.setState({ containerSize: sizes });
                        screenfull.on('change', this.fullscreenChangeHandler);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Exit a fullscreen view of the panorama
     */
    InteriorPanoramaViewer.prototype.exitFullScreen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        container = document.getElementById('interior_panorama');
                        if (!(!isNil(container) && screenfull.isEnabled)) return [3 /*break*/, 2];
                        return [4 /*yield*/, screenfull.exit()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Starts/stops autorotation of the panorama
     *
     * @param run true if the autorotation should start, false to stop
     * @param speed speed of the autorotation, default is 100
     */
    InteriorPanoramaViewer.prototype.autorotate = function (run, speed) {
        var _this = this;
        if (speed === void 0) { speed = 100; }
        if (this.state.autorotating && run) {
            return;
        }
        if (run) {
            if (!isNil(this.state.panoViewer)) {
                var start_1 = new Date().getTime();
                var yaw_1 = this.state.panoViewer.getYaw();
                var pitch_1 = this.state.panoViewer.getPitch();
                var doAutorotate_1 = function () {
                    var delta = new Date().getTime() - start_1;
                    if (!isNil(_this.state.panoViewer)) {
                        _this.state.panoViewer.lookAt({
                            yaw: yaw_1 + (delta / speed) % 360,
                            pitch: pitch_1
                        }, 0);
                        if (_this.state.autorotating) {
                            _this.setState({ animationFrameID: window.requestAnimationFrame(doAutorotate_1) });
                        }
                    }
                };
                this.setState({
                    autorotating: true,
                    animationFrameID: window.requestAnimationFrame(doAutorotate_1),
                    start: start_1,
                });
            }
        }
        else {
            this.setState({ autorotating: false });
            window.cancelAnimationFrame(this.state.animationFrameID);
        }
    };
    /**
     * Show all hotspots which are defined on this panorama
     */
    InteriorPanoramaViewer.prototype.showHotspots = function () {
        if (this.state.hotspotsShown) {
            return;
        }
        if (isNil(this.state.panoViewer)) {
            return;
        }
        this.setState({ hotspotsShown: true });
        this.state.hotspots.forEach(function (hotspot) {
            var element = document.getElementById("panorama_detail_" + hotspot.detailPhoto.name);
            if (isNil(element)) {
                return;
            }
            element.style.visibility = 'visible';
        });
    };
    /**
     * Hide all hotspots which are defined on this panorama
     */
    InteriorPanoramaViewer.prototype.hideHotspots = function () {
        if (!this.state.hotspotsShown) {
            return;
        }
        if (isNil(this.state.panoViewer)) {
            return;
        }
        this.setState({ hotspotsShown: false });
        this.state.hotspots.forEach(function (hotspot) {
            var element = document.getElementById("panorama_detail_" + hotspot.detailPhoto.name);
            if (isNil(element)) {
                return;
            }
            element.style.visibility = 'hidden';
        });
    };
    /**
     * Returns if hotspots are currently shown on this panorama
     */
    InteriorPanoramaViewer.prototype.getHotspotsShown = function () {
        return this.state.hotspotsShown;
    };
    InteriorPanoramaViewer.prototype.toRadian = function (deg) {
        return deg * Math.PI / 180;
    };
    InteriorPanoramaViewer.prototype.getHFov = function (fov) {
        var container = document.getElementById('interior_panorama');
        if (!isNil(container)) {
            var rect = container.getBoundingClientRect();
            var width = rect.width;
            var height = rect.height;
            return Math.atan(width / height * Math.tan(this.toRadian(fov) / 2)) / Math.PI * 360;
        }
        else {
            return 65;
        }
    };
    InteriorPanoramaViewer.prototype.rotate = function (point, deg) {
        var rad = this.toRadian(deg);
        var cos = Math.cos(rad);
        var sin = Math.sin(rad);
        return [cos * point[0] - sin * point[1], sin * point[0] + cos * point[1]];
    };
    InteriorPanoramaViewer.prototype.setHotspotOffset = function (hotspot, viewer) {
        var element = document.getElementById("panorama_detail_" + hotspot.detailPhoto.name);
        if (isNil(element)) {
            return;
        }
        var oyaw = viewer.getYaw();
        var opitch = viewer.getPitch();
        var yaw = hotspot.detailPhoto.x;
        var pitch = hotspot.detailPhoto.y;
        var deltaYaw = yaw - oyaw;
        var deltaPitch = pitch - opitch;
        if (deltaYaw < -180) {
            deltaYaw += 360;
        }
        else if (deltaYaw > 180) {
            deltaYaw -= 360;
        }
        if (Math.abs(deltaYaw) > 90) {
            element.style.transform = 'translate(-200px, 0px)';
            element.style.display = 'hidden';
            return;
        }
        var radYaw = this.toRadian(deltaYaw);
        var radPitch = this.toRadian(deltaPitch);
        var fov = viewer.getFov();
        var hfov = this.getHFov(fov);
        var rx = Math.tan(this.toRadian(hfov) / 2);
        var ry = Math.tan(this.toRadian(fov) / 2);
        var point = [
            Math.tan(-radYaw) / rx,
            Math.tan(-radPitch) / ry,
        ];
        // Image rotation compensation
        // The original image is about 10 degrees tilted.
        point = point.map(function (p) {
            return p * Math.cos(15 / 180 * Math.PI);
        });
        point[1] = this.rotate(point, deltaYaw > 0 ? -10 : 10)[1];
        // point[0] /= 1.05;
        // @ts-ignore
        var left = viewer._width / 2 + point[0] * viewer._width / 2;
        // @ts-ignore
        var top = viewer._height / 2 + point[1] * viewer._height / 2;
        element.style.transform = 'translate(' + left + 'px, ' + top + 'px) translate(-50%, -50%)';
    };
    InteriorPanoramaViewer.prototype.render = function () {
        return (React.createElement("div", { id: 'interior_panorama', className: 'InteriorPanoramaView', style: { overflow: 'hidden' }, key: 'interior_container' },
            map(this.state.hotspots, function (hotspot) {
                return hotspot.element;
            }),
            this.props.children));
    };
    return InteriorPanoramaViewer;
}(React.Component));
export default InteriorPanoramaViewer;
